import React from "react";

const CircularProgress = ({ className }) => (
  <div className={`loader ${className}`}>
    <img src={require("assets/images/finbit.png")} alt="loader" />
  </div>
);
export default CircularProgress;
